import Vue from 'vue';

const STORAGE_KEY = 'INDEX_TOKEN';

export default {
  install(_Vue) {
    const TOKEN = window.localStorage.getItem(STORAGE_KEY);
    if (TOKEN) {
      this.login(TOKEN);
    }
    _Vue.prototype.$auth = this;
    _Vue.auth = this;
  },
  login(token) {
    Vue.http.setHeader('Authorization', `Token ${token}`);
    window.localStorage.setItem(STORAGE_KEY, token);
  },
  logout() {
    Vue.http.removeHeader('Authorization');
    window.localStorage.removeItem(STORAGE_KEY);
    window.location.reload()
  },
  isAuth() {
    return window.localStorage.getItem(STORAGE_KEY);
  },
};
